/**
 * HomeLayoutDefault - Default homepage layout wrapper
 * Wraps the existing HomePageContent with optional Live Zone integration
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { LiveZone } from '../../../components/live/index.mjs';

const HomeLayoutDefault = ({ children }) => {
    const liveZonePrefs = useSelector(state =>
        state.pageLayoutSettings?.userLiveZonePreferences || {}
    );

    const liveZoneEnabled = liveZonePrefs.enabled !== false;
    const liveZonePosition = liveZonePrefs.position || 'top';

    return (
        <div className="home-layout home-layout--default">
            {/* Live Zone at top if configured */}
            {liveZoneEnabled && liveZonePosition === 'top' && (
                <LiveZone position="top" />
            )}

            {/* Main content */}
            <div className="home-layout__body">
                {children}
            </div>

            {/* Live Zone at bottom if configured */}
            {liveZoneEnabled && liveZonePosition === 'bottom' && (
                <LiveZone position="bottom" />
            )}
        </div>
    );
};

export default HomeLayoutDefault;
